/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import Interface from"../base/Interface";export default Interface.create("AudioTrackStrategy",{prepare:["player","audioTrackOption"],getAudioTracks:[],setAudioTrack:["id"],getAudioTrackAttribute:["id","attribute","defaultValue"],getCurrentAudioTrack:[]});